export default {
  bind: function (el, binding, vnode) {
    /*
     * This function binds as a directive to the Vue component and detects clicks
     * which isn't on the element or children if there is a click then it will
     * trigger the handler on the v-click-outside tag.
     */
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};
